import { Provider } from 'react-redux';
import { HashRouter } from 'react-router';

import { store } from './configuration/setup/store';
import { ErrorBoundary } from './features/app/ErrorBoundary';
import App from './features/app/App';
import { main } from './configuration';
import { createRoot } from 'react-dom/client';
import type { User } from 'oidc-client-ts';
import { config } from './config';
import { InvalidLogin } from './features/app/InvalidLogin';
import { handleSilentSigninRedirectInIframe } from './configuration/login/redirect';

const renderApplication = (user?: User | undefined | null) => {
    const container = document.getElementById('root') as Element;
    const root = createRoot(container);

    let showApp = true;

    if (config.isTestTenantMode && !user?.profile?.sub?.startsWith('azure-my-rio-de:')) {
        showApp = false;
    }

    if (showApp) {
        root.render(
            <ErrorBoundary>
                <Provider store={store}>
                    <HashRouter>
                        <App />
                    </HashRouter>
                </Provider>
            </ErrorBoundary>
        );
    } else {
        root.render(<InvalidLogin idToken={user?.id_token} />);
    }
};

const isDev = import.meta.env.DEV;
const isProd = import.meta.env.PROD;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;

if ((isDev && config.enableMockServer) || isProdPreview) {
    import('../mocks/browser').then(({ startWorker }) => startWorker()).then(() => main(renderApplication));
}

const isRedirect = window.location.href.startsWith(config.login.redirectUri as string);
const runsInIframe = 'parent' in window && window.parent !== window;

if (isRedirect && runsInIframe) {
    void handleSilentSigninRedirectInIframe();
} else if (isProd && !isProdPreview) {
    void main(renderApplication);
}
